import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const sendEmailToClient = (
  emailTemplateId,
  locating,
  replace,
  subjectlocating,
  subjectreplace,
  toEmailUser
) => {
  return api.post(`${ApiEndpointConstants.SEND_EMAIL_TO_CLIENT}`, {
    emailTemplateId,
    locating,
    replace,
    subjectlocating,
    subjectreplace,
    toEmailUser,
    username: "admin",
  });
};
